import { NestedTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import {
  PlantGroupElement,
  PlantModelElement,
} from 'src/app/models/O3AdministrationModels/plant-model';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { UserManu } from 'src/app/models/userManu';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { ProductBulkUploadService } from 'src/app/services/product-bulk-upload.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
@Component({
  selector: 'app-plant-model',
  templateUrl: './plant-model.component.html',
  styleUrls: ['./plant-model.component.scss'],
})
export class PlantModelComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<PlantModelElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  formMode!: boolean;
  edited = false;
  plantModelColumns: string[] = [
    'plantModelActions',
    'EGId',
    'EGDesc',
    'Remarks',
    'GrpOrder',
    'IsActive',
    'NoOfLicense',
    'CreatedBy',
    'CreatedOn',
  ];
  plantModelData!: MatTableDataSource<PlantModelElement>;
  addNewPlantModeItemlForm!: FormGroup;
  isaddNewPlantModeItemModelVisible = false;
  addNewPlantModeItemlFormSubmitted = false;
  plnatPermission!: UserManu;

  plantgroup!: any;
  plantgroupFormMode!: boolean;
  isPlantGroupModelVisible = false;
  excelData: any = [];
  addnewGroupModelTitle = '';
  addNewGroupItemForm!: FormGroup;
  isaddNewGroupItemModelVisible = false;
  addNewGroupItemFormSubmitted = false;
  newGroupItemParent!: PlantGroupElement;
  breadcrumList!: any;
  ExportPG: any = [];
  ExportPara: any = [];
  ExportPS: any = [];
  editGroupModelTitle = '';
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();

  plantModelRowId!: number;
  permisson!: any;
  IsAccess!: any;
  IsWrite!: any;
  loading = false;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  // parent node
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length >= 0 && node.NextLevel != null;
  TreeModelData: any = [];
  @ViewChild('treeSelector') tree: any;
  constructor(
    private formBuilder: FormBuilder,
    private platModelService: EnterPriseGroupService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private userManagementService: UserManagementService,
    public router: Router,
    private productBulkUploadService: ProductBulkUploadService,
    public translater: TranslaterService,
    public translate: TranslateService,
    private cd: ChangeDetectorRef
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});
  }

  ngOnInit(): void {
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.formMode = true;
    this.plantgroupFormMode = true;
    this.addNewPlantModeItemlForm = this.formBuilder.group({
      groupDescription: ['', Validators.required],
      groupOrder: ['', Validators.required],
      active: [false],
      remarks: ['', Validators.required],
      noOfLic: ['', Validators.required],
    });
    this.addNewGroupItemForm = this.formBuilder.group({
      description: ['', Validators.required],
      order: ['', Validators.required],
      optional: [''],
      active: [''],
      remarks: [''],
    });
    this.getPlantModel();
  }
  // start add new plant methods
  openaddNewPlantItemModel(): void {
    this.addNewPlantModeItemlForm.reset();
    this.isaddNewPlantModeItemModelVisible = true;
    this.formMode = true;
  }
  closeaddNewPlantItemModel(): void {
    this.isaddNewPlantModeItemModelVisible = false;
  }

  addNewPlantModeItemlFormSubmit(): void {
    const groupKey = {
      EGDesc: this.addNewPlantModeItemlForm.value.groupDescription,
      Remarks: this.addNewPlantModeItemlForm.value.remarks,
      IsActive: this.addNewPlantModeItemlForm.value.active,
      GrpOrder: this.addNewPlantModeItemlForm.value.groupOrder,
      EGId: 0,
      NoOfLic: this.addNewPlantModeItemlForm.value.noOfLic,
      TransactionTypeId: 1,
    };
    this.platModelService.submitGroup(groupKey).subscribe(
      (response: any) => {
        this.toaster.success('Success', response.ErrorMessage);
        // this.showPopupMsg(response.ErrorMessage);
        this.closeaddNewPlantItemModel();
        this.getPlantModel();
        this.addNewPlantModeItemlForm.reset();
      },
      (error) => {
        this.toaster.error('Error', error.error.err.message);
      }
    );
    this.table.renderRows();
    this.addNewPlantModeItemlForm.reset();
    this.isaddNewPlantModeItemModelVisible = false;
  }
  // end add new plant methods
  // start edit plant methods
  openEditPlantItemModel(element: any): void {
    this.spinner.show();
    const key = {
      EGId: element.EGId,
    };
    // if (this.plnatPermission.IsUpdate) {
    this.platModelService.getGroupList(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        const groupdata = data.groupList[0];
        this.openaddNewPlantItemModel();
        this.plantModelRowId = element.EGId;
        this.addNewPlantModeItemlForm
          .get('groupDescription')
          ?.setValue(groupdata.EGDesc);
        this.addNewPlantModeItemlForm
          .get('groupOrder')
          ?.setValue(groupdata.GrpOrder);
        this.addNewPlantModeItemlForm.get('active')?.setValue(element.IsActive);
        this.addNewPlantModeItemlForm.get('remarks')?.setValue(element.Remarks);
        this.addNewPlantModeItemlForm.get('noOfLic')?.setValue(element.NoOfLic);
        this.formMode = false;
      },
      (error) => {
        this.spinner.hide();

        this.toaster.error('Error', error.error.message);
      }
    );
    // }else {
    //   this.toaster.error(
    //     'Alert!',
    //     'you do not have permission to access'
    //   );
    // }
  }
  editPlantModeItemlFormSubmit(): void {
    const groupKey = {
      EGDesc: this.addNewPlantModeItemlForm.value.groupDescription,
      Remarks: this.addNewPlantModeItemlForm.value.remarks,
      IsActive: this.addNewPlantModeItemlForm.value.active,
      GrpOrder: this.addNewPlantModeItemlForm.value.groupOrder,
      EGId: this.plantModelRowId,
      NoOfLic: this.addNewPlantModeItemlForm.value.noOfLic,
      TransactionTypeId: 2,
    };
    this.platModelService.submitGroup(groupKey).subscribe(
      (response: any) => {
        // this.toaster.success('Success', 'Group Update Successfully');
        this.showPopupMsgForGroup(response.ErrorMessage);
        this.getPlantModel();
        this.addNewPlantModeItemlForm.reset();
      },
      (error) => {
        this.toaster.error('Error', error.error.err.message);
      }
    );
    this.table.renderRows();
    this.addNewPlantModeItemlForm.reset();
    this.isaddNewPlantModeItemModelVisible = false;
    this.table.renderRows();
  }
  // end edit plant methods
  // Start Delete Group
  deleteGroup(EGId: number): void {
    if (this.plnatPermission.IsDelete) {
      this.plantModelRowId = EGId;
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete Group!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((result) => {
        if (result.value) {
          const groupKey = {
            EGDesc: '',
            Remarks: '',
            IsActive: 0,
            GrpOrder: 1,
            EGId,
            TransactionTypeId: 3,
          };
          this.platModelService.submitGroup(groupKey).subscribe(
            (success: any) => {
              this.showPopupMsgForGroup(success.ErrorMessage);
              Swal.fire({
                title: 'Deleted!',
                text: 'Your selected Group has been deleted.',
                icon: 'success',
                timer: 800,
                showConfirmButton: false,
              });
              this.getPlantModel();
            },
            (error) => {
              this.toaster.error('Error', error.error.message);
            }
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Your Group is safe :)', 'error');
        }
      });
    } else {
      this.toaster.error('Alert!', 'you do not have permission to access');
    }
  }
  // End Delete Group
  // start plant group methods
  openPlantGroupModel(element: any): void {
    this.plantGroupSource.data = [];
    this.treeControl.dataNodes = this.plantGroupSource.data;
    // this.isPlantGroupModelVisible = true;
    this.getTreeModel(element);
    this.plantgroup = element;
  }

  closePlantGroupModel(): void {
    this.isPlantGroupModelVisible = false;
  }

  collapseAllNode(): void {
    this.treeControl.collapseAll();
  }

  expandAllNode(): void {
    this.treeControl.expandAll();
  }

  treeExpandCollapse(node: any) {

    console.log('node', node);
    console.log('this.treeControl', this.treeControl);
    console.log('this.tree', this.tree);

    let TreeModelList = JSON.parse(JSON.stringify(this.TreeModelData));
    if (node.Level == "Group") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.PrimaryId);
      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj]) {
          TreeModelList[findgrpobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj])
      }
    }
    else if (node.Level == "Plant") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any) => grpchild.children = []);

          // const pntExpandArr = [];
          // this.treeControl.dataNodes[findgrpobj].children.map((grpchildrens: any, index: any) => {
          //   if (this.treeControl.isExpanded(grpchildrens)) {
          //     pntExpandArr.push(index)
          //   }
          // });

          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;


          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])

          // for (const expandPnt of pntExpandArr)
          //   this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[expandPnt])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
      }
    }
    else if (node.Level == "Division") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });
      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])

      }
    }
    else if (node.Level == "Department") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.divisionId);

      const finddeptobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.findIndex((dept: any) => dept.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddeptobj)
          grpchild.children = []
      });
      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
      }
    }
    else if (node.Level == "Line") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.divisionId);

      const finddeptobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.findIndex((dept: any) => dept.PrimaryId == node.departmentId);

      const findlineobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.findIndex((lin: any) => lin.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddeptobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.map((grpchild: any, ind: any) => {
        if (ind != findlineobj)
          grpchild.children = []
      });

      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj])
      }
    }
    else if (node.Level == "Unit") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.divisionId);

      const finddeptobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.findIndex((dept: any) => dept.PrimaryId == node.departmentId);

      const findlineobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.findIndex((lin: any) => lin.PrimaryId == node.lineId);

      const findunitobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.findIndex((unit: any) => unit.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddeptobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.map((grpchild: any, ind: any) => {
        if (ind != findlineobj)
          grpchild.children = []
      });

      // TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.map((grpchild: any, ind: any) => {
      //   if (ind != findlineobj)
      //     grpchild.children = []
      // });

      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj])
      }
    }
    else if (node.Level == "Assembly") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.divisionId);

      const finddeptobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.findIndex((dept: any) => dept.PrimaryId == node.departmentId);

      const findlineobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.findIndex((lin: any) => lin.PrimaryId == node.lineId);

      const findunitobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.findIndex((unit: any) => unit.PrimaryId == node.unitId);

      const findassobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.findIndex((ass: any) => ass.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddeptobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.map((grpchild: any, ind: any) => {
        if (ind != findlineobj)
          grpchild.children = []
      });

      // TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.map((grpchild: any, ind: any) => {
      //   if (ind != findlineobj)
      //     grpchild.children = []
      // });

      // TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.map((grpchild: any, ind: any) => {
      //   if (ind != findassobj)
      //     grpchild.children = []
      // });

      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj])
      }
    }
    else if (node.Level == "SubAssembly") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.divisionId);

      const finddeptobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.findIndex((dept: any) => dept.PrimaryId == node.departmentId);

      const findlineobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.findIndex((lin: any) => lin.PrimaryId == node.lineId);

      const findunitobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.findIndex((unit: any) => unit.PrimaryId == node.unitId);

      const findassobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.findIndex((ass: any) => ass.PrimaryId == node.assemblyId);

      const findsubassobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children.findIndex((ass: any) => ass.PrimaryId == node.PrimaryId);

      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddeptobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.map((grpchild: any, ind: any) => {
        if (ind != findlineobj)
          grpchild.children = []
      });

      // TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.map((grpchild: any, ind: any) => {
      //   if (ind != findlineobj)
      //     grpchild.children = []
      // });

      // TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.map((grpchild: any, ind: any) => {
      //   if (ind != findassobj)
      //     grpchild.children = []
      // });

      // TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children.map((grpchild: any, ind: any) => {
      //   if (ind != findsubassobj)
      //     grpchild.children = []
      // });

      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj])
      }
    }
    else if (node.Level == "Component") {
      const findgrpobj = TreeModelList.findIndex((grp: any) => grp.PrimaryId == node.groupId);

      const findpntobj = TreeModelList[findgrpobj].children.findIndex((pnt: any) => pnt.PrimaryId == node.plantId);

      const finddivobj = TreeModelList[findgrpobj].children[findpntobj].children.findIndex((div: any) => div.PrimaryId == node.divisionId);

      const finddeptobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.findIndex((dept: any) => dept.PrimaryId == node.departmentId);

      const findlineobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.findIndex((lin: any) => lin.PrimaryId == node.lineId);

      const findunitobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.findIndex((unit: any) => unit.PrimaryId == node.unitId);

      const findassobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.findIndex((ass: any) => ass.PrimaryId == node.assemblyId);

      const findsubassobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children.findIndex((subass: any) => subass.PrimaryId == node.subAssemblyId);

      const findcompobj = TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children.findIndex((com: any) => com.PrimaryId == node.PrimaryId);


      TreeModelList[findgrpobj].children.map((grpchild: any, ind: any) => {
        if (ind != findpntobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddivobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children.map((grpchild: any, ind: any) => {
        if (ind != finddeptobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children.map((grpchild: any, ind: any) => {
        if (ind != findlineobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children.map((grpchild: any, ind: any) => {
        if (ind != findlineobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children.map((grpchild: any, ind: any) => {
        if (ind != findcompobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children.map((grpchild: any, ind: any) => {
        if (ind != findsubassobj)
          grpchild.children = []
      });

      TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children.map((grpchild: any, ind: any) => {
        if (ind != findsubassobj)
          grpchild.children = []
      });

      if (this.treeControl.isExpanded(node)) {
        if (TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children[findcompobj]) {
          TreeModelList[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children[findcompobj].children.map((grpchild: any) => grpchild.children = []);
          this.plantGroupSource.data = []
          this.treeControl.dataNodes = []
          this.plantGroupSource.data = [TreeModelList[findgrpobj]];
          this.treeControl.dataNodes = this.plantGroupSource.data;
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj])
          this.treeControl.expand(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children[findcompobj])
        }
      }
      else {
        this.treeControl.collapse(this.treeControl.dataNodes[findgrpobj].children[findpntobj].children[finddivobj].children[finddeptobj].children[findlineobj].children[findunitobj].children[findassobj].children[findsubassobj].children[findcompobj])
      }
    }

    this.cd.detectChanges();
  }

  udpateNodeParentDetails() {
    if (this.TreeModelData && this.TreeModelData.length) {
      this.TreeModelData.forEach((group, groupIndex) => {
        if (group.children && group.children.length) {
          group.children.forEach((plant, plantIndex) => {
            plant.groupName = group.text;
            plant.groupId = group.PrimaryId;
            if (plant.children && plant.children.length) {
              plant.children.forEach((division: any, divisionIndex: number) => {
                division.plantId = plant.PrimaryId;
                division.plantName = plant.text;
                division.groupName = group.text;
                division.groupId = group.PrimaryId;
                if (division.children && division.children.length) {
                  division.children.forEach((department: any, departmentIndex: number) => {
                    department.divisionId = division.PrimaryId;
                    department.divisionName = division.text;
                    department.plantId = plant.PrimaryId;
                    department.plantName = plant.text;
                    department.groupId = group.PrimaryId;
                    department.groupName = group.text;
                    if (department.children && department.children.length) {
                      department.children.forEach((line: any) => {
                        line.departmentId = department.PrimaryId;
                        line.departmentName = department.text;
                        line.divisionId = division.PrimaryId;
                        line.divisionName = division.text;
                        line.plantId = plant.PrimaryId;
                        line.plantName = plant.text;
                        line.groupId = group.PrimaryId;
                        line.groupName = group.text;
                        if (line.children && line.children.length) {
                          line.children.forEach((unit: any) => {
                            unit.lineId = line.PrimaryId;
                            unit.lineName = line.text;
                            unit.departmentId = department.PrimaryId;
                            unit.departmentName = department.text;
                            unit.divisionId = division.PrimaryId;
                            unit.divisionName = division.text;
                            unit.plantId = plant.PrimaryId;
                            unit.plantName = plant.text;
                            unit.groupId = group.PrimaryId;
                            unit.groupName = group.text;
                            if (unit.children && unit.children.length) {
                              unit.children.forEach((assembly: any) => {
                                assembly.unitName = unit.text;
                                assembly.unitId = unit.PrimaryId;
                                assembly.lineId = line.PrimaryId;
                                assembly.lineName = line.text;
                                assembly.departmentId = department.PrimaryId;
                                assembly.departmentName = department.text;
                                assembly.divisionId = division.PrimaryId;
                                assembly.divisionName = division.text;
                                assembly.plantId = plant.PrimaryId;
                                assembly.plantName = plant.text;
                                assembly.groupId = group.PrimaryId;
                                assembly.groupName = group.text;
                                if (assembly.children && assembly.children.length) {
                                  assembly.children.forEach((subAssembly: any) => {
                                    subAssembly.assemblyName = assembly.text;
                                    subAssembly.assemblyId = assembly.PrimaryId;
                                    subAssembly.unitName = unit.text;
                                    subAssembly.unitId = unit.PrimaryId;
                                    subAssembly.lineId = line.PrimaryId;
                                    subAssembly.lineName = line.text;
                                    subAssembly.departmentId = department.PrimaryId;
                                    subAssembly.departmentName = department.text;
                                    subAssembly.divisionId = division.PrimaryId;
                                    subAssembly.divisionName = division.text;
                                    subAssembly.plantId = plant.PrimaryId;
                                    subAssembly.plantName = plant.text;
                                    subAssembly.groupId = group.PrimaryId;
                                    subAssembly.groupName = group.text;
                                    if (subAssembly.children && subAssembly.children.length) {
                                      subAssembly.children.forEach((component: any) => {
                                        component.subAssemblyName = subAssembly.text;
                                        component.subAssemblyId = subAssembly.PrimaryId;
                                        component.assemblyName = assembly.text;
                                        component.assemblyId = assembly.PrimaryId;
                                        component.unitName = unit.text;
                                        component.unitId = unit.PrimaryId;
                                        component.lineId = line.PrimaryId;
                                        component.lineName = line.text;
                                        component.departmentId = department.PrimaryId;
                                        component.departmentName = department.text;
                                        component.divisionId = division.PrimaryId;
                                        component.divisionName = division.text;
                                        component.plantId = plant.PrimaryId;
                                        component.plantName = plant.text;
                                        component.groupId = group.PrimaryId;
                                        component.groupName = group.text;
                                      })
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    }
  }
  // end plant group methods
  // start group model methods
  openaddNewGroupModel(element: PlantGroupElement): void {
    // if (this.plnatPermission.IsCreate) {
    this.plantgroupFormMode = true;
    this.newGroupItemParent = element;
    this.addnewGroupModelTitle = element.NextLevel; // (element.NextLevel === 'Unit' ? 'Machine' : element.NextLevel);
    this.addNewGroupItemForm.reset();
    this.isPlantGroupModelVisible = false;
    this.isaddNewGroupItemModelVisible = true;
    // tslint:disable-next-line: max-line-length
    if (
      element.NextLevel === 'Plant' ||
      element.NextLevel === 'Division' ||
      element.NextLevel === 'Department' ||
      element.NextLevel === 'Assembly' ||
      element.NextLevel === 'SubAssembly'
    ) {
      this.edited = true;
    } else {
      this.edited = false;
    }
    // } else {
    //   this.toaster.error('Alert!', 'you do not have permission to access');
    // }
  }
  addNewGroupModeItemlFormSubmit(): void {
    const data = {
      Desc: this.addNewGroupItemForm.value.description,
      Remarks: this.addNewGroupItemForm.value.remarks,
      IsOptional: this.addNewGroupItemForm.value.optional,
      IsActive: this.addNewGroupItemForm.value.active,
      Order: this.addNewGroupItemForm.value.order,
      Level: this.newGroupItemParent.Level,
      PrimaryId: this.newGroupItemParent.PrimaryId,
      ParentId: this.newGroupItemParent.parentId,
      TransactionTypeId: 1,
    };
    this.platModelService.addPlantModalTree(data).subscribe(
      (response) => {
        // this.toaster.success('Success', response.ErrorMessage);
        this.showPopupMsg(response.ErrorMessage);
        // this.isaddNewGroupItemModelVisible = false;
        // this.isPlantGroupModelVisible = true;
        this.getTreeModel(this.plantgroup);
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  showPopupMsg(msg: any): any {
    if (msg.substring(2, 1) === '0') {
      this.toaster.success('Success', msg.substring(3, msg.length));
      this.isaddNewGroupItemModelVisible = false;
      this.isPlantGroupModelVisible = true;
    } else {
      this.toaster.error('Error', msg.substring(3, msg.length));
    }
  }
  showPopupMsgForGroup(msg: any): any {
    if (msg.substring(2, 1) === '0') {
      this.toaster.success('Success', msg.substring(3, msg.length));
    } else {
      this.toaster.error('Error', msg.substring(3, msg.length));
    }
  }

  closeaddNewGroupModel(): void {
    this.isaddNewGroupItemModelVisible = false;
    this.isPlantGroupModelVisible = true;
  }
  openEditGroupModel(element: PlantGroupElement): void {
    //  if ( this.plnatPermission.IsUpdate ){
    this.plantgroupFormMode = false;
    // tslint:disable-next-line:max-line-length
    if (
      element.Level === 'Plant' ||
      element.Level === 'Division' ||
      element.Level === 'Department' ||
      element.Level === 'Assembly' ||
      element.Level === 'SubAssembly'
    ) {
      this.edited = true;
    } else {
      this.edited = false;
    }
    const data = {
      Level: element.Level,
      PrimaryId: element.PrimaryId,
    };
    this.newGroupItemParent = element;
    this.addnewGroupModelTitle = element.Level; // === 'Line' ? 'Machine' : element.Level);
    this.platModelService.getPlantModalById(data).subscribe(
      (response) => {
        console.log(response);
        this.addNewGroupItemForm
          .get('description')
          ?.setValue(response.ChildModelList[0].Desc);
        this.addNewGroupItemForm
          .get('order')
          ?.setValue(response.ChildModelList[0].Order);
        this.addNewGroupItemForm
          .get('optional')
          ?.setValue(response.ChildModelList[0].IsOptional);
        this.addNewGroupItemForm
          .get('active')
          ?.setValue(response.ChildModelList[0].IsActive);
        this.addNewGroupItemForm
          .get('remarks')
          ?.setValue(response.ChildModelList[0].Remarks);
        this.isaddNewGroupItemModelVisible = true;
        this.isPlantGroupModelVisible = false;
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
    // } else {
    //   this.toaster.error('Alert!', 'you do not have permission to access');
    // }
  }

  editNewGroupModeItemlFormSubmit(): void {
    const data = {
      Desc: this.addNewGroupItemForm.value.description,
      Remarks: this.addNewGroupItemForm.value.remarks,
      IsOptional: this.addNewGroupItemForm.value.optional,
      IsActive: this.addNewGroupItemForm.value.active,
      Order: this.addNewGroupItemForm.value.order,
      Level: this.newGroupItemParent.Level,
      PrimaryId: this.newGroupItemParent.PrimaryId,
      ParentId: this.newGroupItemParent.ParentEditId,
      TransactionTypeId: 2,
      EGId: this.plantgroup.EGId,
    };
    this.platModelService.addPlantModalTree(data).subscribe(
      (response) => {
        this.showPopupMsg(response.ErrorMessage);
        this.getTreeModel(this.plantgroup);
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  deleteGroupNode(node: any): void {
    // if (this.plnatPermission.IsDelete) {
    Swal.fire({
      title: 'Are you sure?',
      text:
        'You want to delete ' + this.replaceIcon(node.icon) + node.text + ' !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const data = {
          Desc: '',
          Remarks: '',
          IsOptional: true,
          IsActive: true,
          Order: 1,
          Level: node.Level,
          PrimaryId: node.PrimaryId,
          ParentId: node.ParentEditId,
          TransactionTypeId: 3,
          EGId: this.plantgroup.EGId,
        };
        console.log(data);
        this.platModelService.addPlantModalTree(data).subscribe((response) => {
          if (response.HasError === false) {
            this.showPopupMsgForGroup(response.ErrorMessage);
            // this.toaster.success('Success', response.ErrorMessage);
            this.isaddNewGroupItemModelVisible = false;
            this.isPlantGroupModelVisible = true;
            this.getTreeModel(this.plantgroup);
          } else {
            this.toaster.error('Error', response.ErrorMessage);
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Your ' + this.replaceIcon(node.icon) + node.text + ' is safe :)',
          'error'
        );
      }
    });
    // } else {
    //   this.toaster.error('Alert!', 'you do not have permission to access');
    // }
  }
  // end group model methods
  getPlantModel(): void {
    this.spinner.show();
    // const userRoles = JSON.parse(localStorage.user).userRoles;
    // const role = userRoles.includes('Super Admin');
    const key = {
      EGId: 0, // : JSON.parse(localStorage.user).egId,
      CreatedBy: JSON.parse(localStorage.user).UserId,
    };

    this.platModelService.getGroupList(key).subscribe(
      (data: any) => {
        this.plantModelData = new MatTableDataSource<PlantModelElement>(
          data.groupList
        );
        this.getPaginator();
        this.spinner.hide();
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
  }
  getPaginator(): void {
    setTimeout(() => {
      this.plantModelData.paginator = this.paginator;
      this.plantModelData.sort = this.sort;
    }, 1000);
  }

  applyFilter(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.plantModelData.filter = filterValue.trim().toLowerCase();
  }
  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }
  replaceString(value: any): any {
    const data = value.split('"')[1];
    if (data === 'IsOptionalplanticon') {
      return true;
    } else {
      return false;
    }
  }
  getTreeModel(element: any): void {
    const key = {
      EGId: element.EGId,
      IsOptional: 1,
    };
    this.spinner.show();
    this.platModelService.getTreeModal(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.isPlantGroupModelVisible = true;
        this.TreeModelData = JSON.parse(JSON.stringify(data.TreeModalList));
        data.TreeModalList[0].children = [];
        const plantGroupData: PlantGroupElement[] = data.TreeModalList;
        this.plantGroupSource.data = data.TreeModalList;
        this.treeControl.dataNodes = this.plantGroupSource.data;
        this.udpateNodeParentDetails();
        // this.expandAllNode();
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.platModelService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.userManagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
    // return false;
  }

  onReadExcel(event: any) {
    this.excelData = event.addedFiles[0];
    const fileName = this.excelData.name;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.excelData);
    fileReader.onload = (e) => {
      let arrayBuffer: any = fileReader.result;
      var data = new Uint8Array(arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join('');
      var workbook = XLSX.read(bstr, { type: 'binary' });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.validateSheet();
    };
  }

  validateSheet() {
    try {
      let user: any = localStorage.getItem('user');
      user = JSON.parse(user);
      let plantMasterData: any = [];
      let PropertyData: any = { createdBy: user.UserId };

      if (this.excelData && this.excelData.length) {
        let index = 0;
        for (let data of this.excelData) {
          const group = this.plantModelData.data.find(
            (grp: any) =>
              grp.EGDesc == data['Group'] ||
              grp.EGDesc.toLowerCase() == data['Group'].toLowerCase()
          );
          if (!group) {
            this.toaster.warning(
              `Group ${data['Group']} doesn't exist in database on line ${index + 1
              }`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Group']) {
            this.toaster.warning(
              `Please Enter Group on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Plant']) {
            this.toaster.warning(
              `Please Enter Plant on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Division'] && data['Department']) {
            this.toaster.warning(
              `Please Enter Division on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Department'] && data['Line']) {
            this.toaster.warning(
              `Please Enter Department on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Line'] && data['Unit']) {
            this.toaster.warning(
              `Please Enter Line on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Unit'] && data['Assembly']) {
            this.toaster.warning(
              `Please Enter Unit on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['Assembly'] && data['SubAssembly']) {
            this.toaster.warning(
              `Please Enter Assembly on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          }
          if (!data['SubAssembly'] && data['Component']) {
            this.toaster.warning(
              `Please Enter SubAssembly on line ${index + 1}`,
              'Warning'
            );
            this.excelData = [];
            return;
          } else {
            //plantMasterData.push(this.excelData,PropertyData);
            plantMasterData.push(
              Object.assign(this.excelData[index], PropertyData)
            );
            console.log('Validation', this.excelData[index]);
          }
          index++;
        }
        const masterData = { plantMasterDatas: plantMasterData };
        console.log('Data', masterData);
        this.uploadMasterDataPlantModel(masterData);
      } else this.toaster.warning('No Data Found', 'Warning');
    } catch (err: any) {
      this.toaster.error(err, 'Error');
    }
  }

  uploadMasterDataPlantModel(masterData: any) {
    this.spinner.show();
    this.productBulkUploadService.uploadMasterDataPlantModel(masterData).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status == 'Plant not available')
          this.toaster.warning(res.status, 'warning');
        else this.toaster.success(res.status, 'Sucess');
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err.message, 'Error');
      }
    );
  }
  ExportTOExcel(name: any) {
    const data = { groupId: name.EGId };
    this.productBulkUploadService.getExcel(data).subscribe((res: any) => {
      this.ExportPG = res;
      console.log('Dass', this.ExportPG);
    });
    if (this.ExportPG && this.ExportPG.length) {
      const workBook = XLSX.utils.book_new(); // create a new blank book

      this.ExportPG = this.ExportPG;
      const PGSheet = XLSX.utils.json_to_sheet([
        ...this.ExportPG,
        ...this.ExportPara,
      ]);

      XLSX.utils.book_append_sheet(workBook, PGSheet, 'Plantmodel'); // add the worksheet to the book
      XLSX.writeFile(workBook, `Plant-Model.xlsx`); // initiate a file
    }
  }
}
